"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _formFieldWrapper = _interopRequireDefault(require("@amzn/meridian-tokens/component/form-field-wrapper"));
var _alert = _interopRequireDefault(require("../alert"));
var _column = _interopRequireDefault(require("../column"));
var _theme = require("../theme");
var _text = _interopRequireDefault(require("./../_styles/text"));
var _token = require("./../_utils/token");
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled,
    size = _ref.size;
  return (0, _css.css)((0, _text["default"])(t), {
    color: disabled ? "".concat(t("labelColorDisabled")) : "".concat(t("labelColorDefault")),
    fontSize: t("labelFontSize", size),
    fontWeight: t("labelFontWeight", size),
    lineHeight: t("labelLineHeight", size),
    cursor: disabled ? "not-allowed" : "default"
  });
}, ["disabled", "size"]);
var supportTextStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled;
  return (0, _css.css)((0, _text["default"])(t), {
    color: disabled ? "".concat(t("supportTextColorDisabled")) : "".concat(t("supportTextColorDefault")),
    fontSize: t("supportTextFontSize"),
    fontWeight: t("supportTextFontWeight"),
    lineHeight: t("supportTextLineHeight"),
    cursor: disabled ? "not-allowed" : "default"
  });
}, ["disabled"]);

/* eslint-disable react/prop-types */
var SupportText = function SupportText(props) {
  var t = props.t,
    id = props.id,
    disabled = props.disabled,
    children = props.children;
  var elementProps = {
    className: supportTextStyles(t, {
      disabled: disabled
    }),
    id: id
  };
  return (0, _typeof2["default"])(children) === "object" ? /*#__PURE__*/_react["default"].createElement("div", elementProps, children) : /*#__PURE__*/_react["default"].createElement("span", elementProps, children);
};
var SupportTextWrapper = function SupportTextWrapper(props) {
  var children = props.children,
    id = props.id,
    className = props.className,
    constraintText = props.constraintText,
    disabled = props.disabled,
    errorMessage = props.errorMessage,
    helperText = props.helperText,
    label = props.label,
    size = props.size,
    showRequiredIndicator = props.showRequiredIndicator;
  var t = (0, _theme.useTheme)(_formFieldWrapper["default"], "formFieldWrapper");
  var helperBelowFormField = size === "xlarge";
  var hasStaticLabel = size !== "xlarge";
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: className,
    spacing: "200"
  }, label && hasStaticLabel && /*#__PURE__*/_react["default"].createElement("label", {
    id: "".concat(id, "-label"),
    htmlFor: id,
    className: labelStyles(t, {
      disabled: disabled,
      size: props.size
    })
  }, label, showRequiredIndicator ? /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "*") : null), helperText && !helperBelowFormField && /*#__PURE__*/_react["default"].createElement(SupportText, {
    disabled: disabled,
    id: "".concat(id, "-helper-text"),
    t: t
  }, helperText), children, errorMessage && /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "100 none none none"
  }, /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    id: "".concat(id, "-error-message"),
    type: "error",
    size: "small"
  }, errorMessage)), helperText && helperBelowFormField && /*#__PURE__*/_react["default"].createElement(SupportText, {
    disabled: disabled,
    id: "".concat(id, "-helper-text"),
    t: t
  }, helperText), constraintText && /*#__PURE__*/_react["default"].createElement(SupportText, {
    disabled: disabled,
    id: "".concat(id, "-constraint-text"),
    t: t
  }, constraintText));
};
SupportTextWrapper.displayName = "SupportTextWrapper";
SupportTextWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  /**
   * The id used for the child form field component.
   * This will be used to generate the id's for the support text.
   * EG: "my-input" as an id will become "my-input-helper-text"
   * for the helper text's id.
   */
  id: _propTypes["default"].string.isRequired,
  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  /**
   * Add constraint text to provide critical information regarding form field content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * Whether or not the form field wrapped by the support text wrapper is disabled or not.
   * This will set the appropriate color and cursor styles on the form field labels and support text.
   */
  disabled: _propTypes["default"].bool,
  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the form field.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * The label for the form field component.
   * This is shown as text above the form field for non-xlarge form fields
   *
   * NOTE: Textarea's with size of medium are treated as xlarge form fields
   */
  label: _propTypes["default"].string,
  /**
   * When true, appends an "*" to the form field's label. The indicator is hidden from
   * screen readers to prevent them from announcing "*" as "star" or some other unhelpful
   * descriptor.
   */
  showRequiredIndicator: _propTypes["default"].bool,
  /**
   * The size of the form field within the support text wrapper. This is used to
   * set the appropriate `fontSize` for the label.
   
   * Small form fields have labels with 14px font size.
   * Medium and larged have labels that are 16px font size.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"])
} : {};
SupportTextWrapper.defaultProps = {
  size: "medium"
};
var _default = SupportTextWrapper;
exports["default"] = _default;